export const en = {
  avatarTitle: "%s's avatar",
  editPicture: 'Edit Picture',
  uploadMessage: 'Upload a picture here (1 MB max file size)',
}

export const es = en
